module.exports = __webpack_public_path__ + "img/personnelLedger.a1cf3a8b.png";